import { apiClient } from '@/lib/api'

/**
 * Lead Dictionaries API - Lead Types, Client Types, Purchase Types
 */

// Lead Types
export const leadTypesApi = {
    getAll: (params = {}) => apiClient.get('/v1/leads/dicts/lead-types/', { params }),
}

// Client Types
export const clientTypesApi = {
    getAll: (params = {}) => apiClient.get('/v1/leads/dicts/client-types/', { params }),
}

// Purchase Types
export const purchaseTypesApi = {
    getAll: (params = {}) => apiClient.get('/v1/leads/dicts/purchase-types/', { params }),
}

// Combined export
export const leadDictionariesApi = {
    leadTypesApi,
    clientTypesApi,
    purchaseTypesApi,
}
